import {mapGetters} from "vuex";
import moment from "moment";

export default {
    data: () => {
        return {
            isLandscape: false,
            containerClass: 'card-image__container__landscape',
            showLoader: true,
            loaded: false,
            route: '',
            mainProps: {
                center: true,
                fluidGrow: true,
                blank: true
            }
        }
    },
    props: {
        img: null,
        item: null,
        size: {
            type: String,
            default: 'contain'
        },
        group: false
    },
    mounted() {
        if (this.item.model === 'event') {
            this.route = {name: 'event.view', params: {id: this.item.id, slug: this.item.slug}}
        } else if (this.item.model === 'project') {
            this.route = {name: 'project.view', params: {id: this.item.id, slug: this.item.slug}}
        } else if (this.item.model === 'people') {
            this.route = {name: 'people.view', params: {id: this.item.id, slug: this.item.slug}}
        }
        let image = this.$refs.image;
        if (image) {
            image.onload = () => {
                if (image.naturalHeight < image.naturalWidth) {
                    this.isLandscape = true;
                } else if (image.naturalHeight > image.naturalWidth) {
                    this.isLandscape = false;
                    this.containerClass = 'card-image__container__portrait';
                } else {
                    this.isLandscape = true;
                    this.containerClass = 'card-image__container__square';
                }

            }
        }
    },
    computed: {
        ...mapGetters('event', {
            getThumbnail: 'getEventThumbnail'
        }),
        ...mapGetters('color', [
            'getColorForModel'
        ]),
        color() {
            return this.getColorForModel(this.item.model)
        },
        labelColor() {
            return {
                '--color': 'transparent',
                '--color-hover': this.getColorForModel(this.item.model)
            }
        },
        captionType() {
            if (this.item.model === 'event') {
                return this.$t('capital.event')
            } else if (this.item.model === 'project') {
                return this.$t('capital.project')
            } else if (this.item.model === 'people') {
                return this.$t('capital.people')
            }
        },
        captionTypes() {
          return this.item.types ? this.item.types : null
        },
        captionTitle() {
            return this.item.title ? this.item.title : (this.item.name ? this.item.name : '')
        },
        captionDate() {
            if (this.item.model === 'event') {
                return this.item.starting_date ? moment.utc(this.item.starting_date).format('DD.MM.YYYY') : ''
            } else if (this.item.model === 'people' && this.item.activities.length) {
                return this.item.activities.join(' / ');
            } else if (this.item.model === 'video') {
                return this.item.starting_date ? moment.utc(this.item.starting_date).format('DD.MM.YYYY') : ''
            }
        },
    },
    methods: {
        checkFormat() {
            this.showLoader = false
        },
        go() {
            this.$router.push(this.route)
        }
    }
}
